import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { LinkExternal01Icon } from '@systemeio/icons';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { pageRoute } from 'shared/constants/routes.constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getPageRoute } from 'shared/utils/get-dynamic-page-route';
export function SubaccountsPageLink() {
  const $ = _c(6);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("header.user.profile.menu.sub_accounts");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LinkWithoutPrefetch href={getPageRoute(pageRoute.Subaccounts)} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LinkExternal01Icon />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0) {
    t3 = <Button aria-label={t0} data-test-id="subaccounts-page-link-button" render={t1} size="icon-xs" variant="ghost-gray">{t2}</Button>;
    $[4] = t0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}